module.exports = __webpack_public_path__ + "exljbris_-_museosans-700-webfont.5edc813e86892c550315.woff";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/exljbris_-_museosans-700-webfont.woff
// module id = ../../../../../src/assets/fonts/exljbris_-_museosans-700-webfont.woff
// module chunks = styles